/**
 * GuestProjectRoute — /guest/:token/project/:projectKey
 * Loads one project the link's user is delegated and renders GuestProjectPage.
 */
import React from 'react';
import { useParams } from 'react-router-dom';
import { PageLoader } from '../../Components/LoadingSpinner';
import { guestApi } from '../../api/guestApi';
import GuestProjectPage from './GuestProjectPage';
import { GuestLinkRefusalPage, GuestLoadErrorPage, GuestLoadingPage, GuestUnavailablePage } from './components/GuestLinkStatePages';
import { useGuestFetch } from './hooks/useGuestFetch';
import './GuestTaskPage.css';

const GuestProjectRoute: React.FC = () => {
    const { token, projectKey } = useParams<{ token: string; projectKey: string }>();
    const { data, loading, refusal, error, notFound } = useGuestFetch(
        () => guestApi.getProject(token as string, projectKey as string),
        token && projectKey ? `${token}/${projectKey}` : null
    );

    if (loading) {
        return (
            <GuestLoadingPage>
                <PageLoader text="Laddar..." />
            </GuestLoadingPage>
        );
    }
    if (refusal && token) {
        return <GuestLinkRefusalPage token={token} refusal={refusal} />;
    }
    if (error && !notFound && token) {
        return <GuestLoadErrorPage title="Kunde inte ladda projektet" message={error} />;
    }
    if (!data || !token || !projectKey) {
        return (
            <GuestUnavailablePage
                title="Projektet är inte längre tillgängligt"
                text="Det kan ha avslutats eller delegerats till någon annan."
                token={token}
            />
        );
    }

    return <GuestProjectPage token={token} projectKey={projectKey} initialData={data} />;
};

export default GuestProjectRoute;
